import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrder, SearchQueryOrderDirection } from "types/generated";

export enum SPACE_USER_SESSIONS_COLUMN_ID {
  NAME = "NAME",
  ROLE = "ROLE",
  ORIGIN = "ORIGIN",
}

export const SPACE_USER_SESSIONS_COLUMNS_STORAGE_KEY = "spaceDetailsUserSessionsColumnsConfig";
export const SPACE_USER_SESSIONS_LIMIT_STORAGE_KEY = "spaceDetailsUserSessionsLimit";
export const SPACE_USER_SESSIONS_FILTERS_ORDER_KEY = "spaceDetailsUserSessionsFiltersOrder";
export const SPACE_USER_SESSIONS_INITIAL_LIMIT = 50;

export const SPACE_USER_SESSIONS_COLUMN_CONFIG: Record<
  SPACE_USER_SESSIONS_COLUMN_ID,
  TableColumnMeta
> = {
  [SPACE_USER_SESSIONS_COLUMN_ID.NAME]: {
    id: SPACE_USER_SESSIONS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: 2000,
    // The backend's `name` sort is a concat of login, name and email, so it orders by login — which
    // is exactly what this column renders.
    allowsSorting: true,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_USER_SESSIONS_COLUMN_ID.ROLE]: {
    id: SPACE_USER_SESSIONS_COLUMN_ID.ROLE,
    title: "Role",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: 400,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
  [SPACE_USER_SESSIONS_COLUMN_ID.ORIGIN]: {
    id: SPACE_USER_SESSIONS_COLUMN_ID.ORIGIN,
    title: "Origin",
    tooltip:
      "Roles on a session come from the login policy evaluated at login, not from a role binding on this space",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: 400,
    // Not sortable: the sessions queries expose only `name` as orderable, and every row carries the
    // same value anyway.
    allowsSorting: false,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
  },
};

export const SPACE_USER_SESSIONS_SORT_CONFIG: Record<string, string> = {
  [SPACE_USER_SESSIONS_COLUMN_ID.NAME]: "name",
};

export const SPACE_USER_SESSIONS_INITIAL_ORDER_BY: SearchQueryOrder = {
  field: SPACE_USER_SESSIONS_SORT_CONFIG[SPACE_USER_SESSIONS_COLUMN_ID.NAME],
  direction: SearchQueryOrderDirection.Asc,
};
